// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportingDetailsGoalsAddPage_wrapper__wjoDX"};